import React from 'react';
import { buyerReviews } from '../data/buyerReviews';
import { ReviewAvatar } from './ReviewAvatar';

/**
 * Pre-launch: shows the three lanes. As soon as real reviews are added to
 * data/buyerReviews.ts, it switches to the buyers' faces automatically.
 */
const lanes = [{
  id: 'L1',
  color: 'bg-mint'
}, {
  id: 'L2',
  color: 'bg-amber'
}, {
  id: 'L3',
  color: 'bg-coral'
}];
type RatingProofProps = {
  tone?: 'dark' | 'light';
};
export function RatingProof({
  tone = 'dark'
}: RatingProofProps) {
  const light = tone === 'light';
  const ring = light ? 'ring-glacier-soft' : 'ring-rink-deep';
  const faces = buyerReviews.slice(0, 4);
  const hasReviews = faces.length > 0;
  return <div className="flex items-center gap-3" data-id="element-370" data-mp="3aiidvv368ja">
      <div className="flex -space-x-2" data-id="element-371" data-mp="3a8t6ahv85en">
        {hasReviews ? faces.map((review, i) => <ReviewAvatar key={review.name} review={review} index={i} className={`h-9 w-9 ring-2 ${ring}`} textClassName="text-[11px]" data-id="element-372" data-mp="204vfo5kk35m4" data-mpi={i} />) : lanes.map(lane => <span key={lane.id} className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-[12px] font-bold text-rink-deep ring-2 ${ring} ${lane.color}`} data-id="element-373" data-mp="19ksb1eg9evfz">
                {lane.id}
              </span>)}
      </div>
      <p className={`text-[13px] leading-snug ${light ? 'text-ink-soft' : 'text-white/75'}`} data-id="element-374" data-mp="1x9v1nbsvfymm">
        {hasReviews ? <>
            <span className={`font-semibold ${light ? 'text-ink' : 'text-white'}`} data-id="element-375" data-mp="1o9yh9mdillxd">
              {faces.map(r => r.name.split(' ')[0]).join(', ')}
            </span>
            <br data-id="element-376" data-mp="1jdpv3p0wgsgp" />
            and other coaches already use it
          </> : <>
            <span className={`font-semibold ${light ? 'text-ink' : 'text-white'}`} data-id="element-377" data-mp="csyj4a4hkcvf">
              Beginner, Developing and Advanced
            </span>
            <br data-id="element-378" data-mp="9eotnns4hpuc" />
            on the same ice, at the same time
          </>}
      </p>
    </div>;
}